<div class="button-container">
  <ng-container *ngIf="!isMobile; else mobileContainer">
    <a data-cy="download-icon" (click)="emitDownloadClick()">
      <ion-icon name="download-outline"></ion-icon>
      <span> {{ 'i18n.common.download' | translate }}</span>
    </a>
    <a data-cy="print-icon" *ngIf="showPrint" (click)="emitPrintClick()">
      <ion-icon name="print-outline"></ion-icon>
      <span>{{ 'i18n.common.print' | translate }}</span>
    </a>
    <a data-cy="share-icon" *ngIf="showShare" (click)="emitShareClick()">
      <ion-icon name="share-social-outline"></ion-icon>
      <span> {{ 'i18n.common.share' | translate }}</span>
    </a>
  </ng-container>
</div>
<ng-template #mobileContainer>
  <a (click)="emitEllipsisClick()">
    <ion-icon
      class="options-icon"
      name="ellipsis-vertical-circle-sharp"
    ></ion-icon>
  </a>
</ng-template>
